import { createContext } from 'react';

const DetailActionContext = createContext({
	currentDetailAction: 0,
	setCurrentDetailAction: () => {},
});

export default DetailActionContext;
